import { i18n } from "../app/i18n/i18n";
import { timeAgo } from "../lib/timeAgo";
import { toUTCDate } from "../lib/dateUtils";
import { createReportUrl } from "./publicationUrls/publicationUrls";

export const isPDFReport = ({ resources = [] }) =>
  resources.filter((res) => res.extension && res.extension === ".pdf").length > 0;

export const existsHtmlFormat = ({ resources = [] }) =>
  resources.filter((res) => res.isCDNReady && res.format === "html5").length > 0;

export const isPodcastUrl = ({ resources = [] }) =>
  resources.filter((res) => res.isCDNReady && (res.extension === ".mp3" || res.extension === ".mp4")).length > 0;

export const formatResponse = (hits, lang = i18n.getLanguage()) =>
  hits.map((el) => {
    el.publicationDateLocale = timeAgo(toUTCDate(el.publicationDate), lang);

    el.PageCount = el.pageCount;
    delete el.pageCount;

    const appName = "GRPUI";
    const cid = "";

    el.commonEndpoint = createReportUrl(el.id, "", appName, cid); // main publication link
    el.pdfUrl = createReportUrl(el.id, ".file", appName, cid); // download as PDF
    el.htmlUrl = existsHtmlFormat(el) ? createReportUrl(el.id, ".html", appName, cid) : null; //used only for labelling
    el.podcastUrl = isPodcastUrl(el) ? createReportUrl(el.id, "", appName, cid) : null;
    el.pubUrl = el.podcastUrl || el.commonEndpoint;

    return el;
  });
